<app-header></app-header>
<div class="flex justify-center w-full h-auto">
  <app-auth-box class="md:w-1/2" (logged)="logged($event)"></app-auth-box>
</div>
